import { EncounterSumary, EncounterSummaryControllerApi } from "../../services";
import { getConfigObject, useMutationWithLoading } from "../../utils/utils";

/**
 * @author Rajkumar Rathod
 */
export const useEncounterCreate = () =>
  useMutationWithLoading(
    async (params: { encounterSumary: EncounterSumary; xTENANTID?: string }) =>
      new EncounterSummaryControllerApi(
        getConfigObject()
      ).createEncounterSummary(params.encounterSumary, params.xTENANTID)
  );
